import React, { useRef, useState } from "react";
import { Box, Flex } from "@100mslive/roomkit-react";

const ChatShell = ({ Header, Pinned, Body, Footer }) => {
  const containerRef = useRef(null);
  const [isPseudoFullscreen, setIsPseudoFullscreen] = useState(false);

  const toggleFullscreen = e => {
    if (e && e.stopPropagation) e.stopPropagation();
    setIsPseudoFullscreen(prev => !prev);
  };

  const headerNode = Header
    ? React.isValidElement(Header)
      ? React.cloneElement(Header, {
          onToggleFullscreen: toggleFullscreen,
          isFullscreen: isPseudoFullscreen,
        })
      : Header
    : null;

  const bodyNode = Body
    ? React.isValidElement(Body)
      ? React.cloneElement(Body, {
          isPseudoFullscreen: isPseudoFullscreen,
        })
      : Body
    : null;

  return (
    <Flex
      direction="column"
      css={{
        size: "100%",
        pointerEvents: "auto",
        ...(isPseudoFullscreen
          ? {
              position: "fixed",
              inset: 0,
              zIndex: 20000,
              bg: "$surface_dim",
              display: "flex",
              flexDirection: "column",
              padding: "24px",
              boxSizing: "border-box",
            }
          : {}),
      }}
      ref={containerRef}
    >
      {headerNode}
      {Pinned}
      <Box css={{ flex: 1, overflow: "visible" }}>{bodyNode}</Box>
      {Footer}
    </Flex>
  );
};

export default ChatShell;
